<template>
  <device-group-list/>
</template>

<script>
import DeviceGroupList from './DeviceList/DeviceGroupList.vue'
export default {
  components: {
    DeviceGroupList
  }
}
</script>

<style scoped>

</style>